import React, { useState } from 'react';
import { useClerk } from '@clerk/clerk-react';
import styles from './Auth.module.css';

export const CustomCreateOrg: React.FC = () => {
  const clerk = useClerk();
  const [orgName, setOrgName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreateOrg = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!orgName.trim()) {
      setError('Organization name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const org = await clerk.createOrganization({ name: orgName.trim() });
      await clerk.setActive({ organization: org.id });
    } catch (err: any) {
      setError(err.errors?.[0]?.message || 'Failed to create organization');
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h1 className={styles.title}>CREATE ORGANIZATION</h1>
          <p className={styles.subtitle}>
            You need an organization to use Interlucent Console
          </p>
        </div>

        {error && (
          <div className={styles.error}>
            {error}
          </div>
        )}

        <form onSubmit={handleCreateOrg} className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label}>ORGANIZATION NAME</label>
            <input
              type="text"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              placeholder="Acme Inc."
              required
              disabled={loading}
              className={styles.input}
              autoFocus
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={styles.button}
          >
            {loading ? 'CREATING...' : 'CREATE ORGANIZATION'}
          </button>
        </form>
      </div>
    </div>
  );
};
